angular.module('app').factory('hiddenGamesService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        return {
            getProviders: function () {
                return restAngular.
                    one("casinoprovider/getSkinProviders").
                    get()
            },
            getCategories: function () {
                return restAngular.
                    one("casinocategory/getSkinCategories").
                    get()
            },
            changeProviderOrder: function (requestData) {
                return restAngular.
                    one("/casinoprovider/changeorderskinproviders").
                    post('', requestData)
            },
            changeCategoryOrder: function (requestData) {
                return restAngular.
                    one("/casinocategory/changeorderskincategories").
                    post('', requestData)
            },
            updateProvider: function (requestData) {
                return restAngular.
                    one("/casinoprovider/changevisibilityskinprovider").
                    post('', requestData)
            },
            updateCategory: function (requestData) {
                return restAngular.
                    one("casinocategory/changevisibilityskinCategory").
                    post('', requestData)
            }
        }
    }
]);